import { useNavigate } from 'react-router-dom';

const BobineLogo = ({ size = 22, className = '', style: customStyle = {} }) => {
  const navigate = useNavigate();
  const imgSize = size * 1.4;
  return (
    <button
      type="button"
      data-testid="bobine-logo"
      className={className}
      onClick={() => navigate('/')}
      style={{
        fontFamily: "'Georgia', serif",
        fontWeight: 500,
        color: '#D4AF37',
        letterSpacing: 2,
        fontSize: size,
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        background: 'none',
        border: 'none',
        padding: '8px 4px',
        margin: '-8px -4px',
        WebkitTapHighlightColor: 'transparent',
        touchAction: 'manipulation',
        ...customStyle,
      }}
    >
      B
      <img
        src="/bobine-face-logo.png"
        alt="O"
        style={{
          height: imgSize,
          width: imgSize,
          objectFit: 'contain',
          margin: '0 -1px',
          filter: 'drop-shadow(0 0 8px rgba(212,175,55,0.4))',
        }}
      />
      BINE
    </button>
  );
};

export default BobineLogo;
